import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ScrollReveal from '../components/ScrollReveal';
import { FiClock, FiArrowRight } from 'react-icons/fi';

export default function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/blogs', {
      headers: {
        'Authorization': 'Basic asrm:asrm@2026'
      }
    })
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          // Filter out unpublished blogs
          const publishedBlogs = data.filter(b => b.is_published === 1 || b.is_published === '1' || b.is_published === true || b.is_published === "true");
          // Sort by date descending
          publishedBlogs.sort((a, b) => new Date(b.dated) - new Date(a.dated));
          setBlogs(publishedBlogs);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Failed to fetch blogs:", err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="page-wrapper">
      <div className="page-hero">
        <ScrollReveal animation="fade-up">
          <h1>Our <span>Blogs</span></h1>
          <p>Insights, updates, and expert analysis from ASRM & Co.</p>
          <div className="service-detail-breadcrumbs" style={{ justifyContent: 'center', marginTop: 12 }}>
            <Link to="/">Home</Link>
            <span className="service-detail-separator">/</span>
            <span className="service-detail-current">Blogs</span>
          </div>
        </ScrollReveal>
      </div>

      <main style={{ padding: '60px 0', background: 'var(--off-white)', minHeight: '50vh' }}>
        <div className="container">
          {loading ? (
            <div style={{ textAlign: 'center', padding: '60px 0', color: 'var(--text-muted)' }}>
              Loading blogs...
            </div>
          ) : blogs.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 0', color: 'var(--text-muted)' }}>
              No blogs available at the moment. Please check back later.
            </div>
          ) : (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: '30px' }}>
              {blogs.map(blog => (
                <div key={blog.id} style={{ 
                  background: 'var(--white)', 
                  borderRadius: 'var(--radius-md)', 
                  overflow: 'hidden',
                  boxShadow: 'var(--shadow-sm)',
                  display: 'flex',
                  flexDirection: 'column',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                }}
                className="blog-card"
                onMouseEnter={e => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = 'var(--shadow-md)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'var(--shadow-sm)';
                }}
                >
                  {blog.image && (
                    <img src={blog.image} alt={blog.title} style={{ width: '100%', height: '200px', objectFit: 'cover' }} />
                  )}
                  <div style={{ padding: '30px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', gap: '16px', color: 'var(--text-muted)', fontSize: '0.85rem', marginBottom: '16px' }}>
                      <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}><FiClock /> {blog.dated}</span>
                    </div>
                    <h3 style={{ fontSize: '1.25rem', color: 'var(--primary-dark)', marginBottom: '16px', lineHeight: 1.4 }}>
                      {blog.title}
                    </h3>
                    <p style={{ color: 'var(--text-dark)', fontSize: '0.95rem', lineHeight: 1.6, marginBottom: '24px', flex: 1 }}>
                      {blog.description.length > 150 ? blog.description.substring(0, 150) + '...' : blog.description}
                    </p>
                    <Link to={`/blogs/${blog.id}`} style={{ 
                      display: 'inline-flex', 
                      alignItems: 'center', 
                      gap: '8px', 
                      color: 'var(--primary)', 
                      fontWeight: 600,
                      textDecoration: 'none'
                    }}>
                      Read More <FiArrowRight />
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
